import { render, staticRenderFns } from "./CredentialClaim.vue?vue&type=template&id=1bd9ee14&"
import script from "./CredentialClaim.vue?vue&type=script&lang=js&"
export * from "./CredentialClaim.vue?vue&type=script&lang=js&"
import style0 from "./CredentialClaim.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports